var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26086149"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#3A5F96",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6692 34.3674C30.0801 37.7903 25.2197 39.8919 19.8685 39.8919C14.7057 39.8919 9.99987 37.9357 6.45166 34.7241C8.71181 31.3306 16.1462 29.6231 20.1911 29.6231C24.0916 29.6231 31.1442 31.2109 33.6692 34.3674ZM27.3954 18.8166C27.3954 22.797 24.1714 26.0209 20.1911 26.0209C16.2107 26.0209 12.9868 22.797 12.9868 18.8166C12.9868 14.8362 16.2107 11.6123 20.1911 11.6123C24.1714 11.6123 27.3954 14.8362 27.3954 18.8166Z",
    fill: "#3A5F96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/PersonIcon.84dfbe0f0936e15662ca9f50edabc0fe.svg";
export { ForwardRef as ReactComponent };